import { runClientComponent } from '../../_common/client/client-component-runner';
import { RecoProductlineComponent } from './reco-productline.component';

runClientComponent({ RecoProductiveComponent: RecoProductlineComponent });
